import * as React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import { Container } from "@material-ui/core"
import Seo from "../components/seo"
import Text from "../components/typography/text"

const Privacy = () => (
<>
<div style={{ width: "100%", background: "#EEF4F9", height: "30vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }} >
                <div style={{ height: "64px" }}/>
                <Text variant={"h1"} black style={{ textAlign: "center" }}>{"Privacy Policy"}</Text>
            </div>



            <Container fixed maxWidth={"md"}>
                <div style={{ padding: "10vh 16px" }}>
                    <Text variant={"body1"} medium >
                    Effective:March 15, 2013.
                    </Text>
                    <div style={{ height: "24px" }}/>
        
                    <Text variant={"body1"} regular>
                    Doctors for Syria (hereinafter “DFS”) is very sensitive to the privacy needs of its website visitors and subscribers and is wholly committed to maintaining privacy at the highest level. DFS does not sell or otherwise share subscribers' or website visitors' personal information with anyone outside the DFS organization.
                        <br/>
                      
                    </Text>
                    <div style={{ height: "48px" }}/>
                   
                    <Text variant={"body1"} regular>
                    DFS never automatically collects any information that specifically identifies you such as your name, address, or e-mail address. This information is collected only when you voluntarily provide it as part of the registration process ("visitor/patient Information"). We will ask you whenever we need Information that identifies you or allows us to contact you. It is your choice whether you provide your identifying information to DFS. However, you should be aware that your personal information is required for DFS to provide you with services
                    </Text>
                    <div style={{ height: "48px" }}/>
                    
                    <Text variant={"body1"} regular>
                    Your registration and any other information provided may be used internally within DFS. For example, DFS may use your information internally to provide services to you and process your questions/inquiries, to contact you for customer service, to communicate to you about your case or changes to our services, to understand who uses its Website and to improve its Website. In addition, DFS reserves the right to disclose your information under limited circumstances in the event DFS believes that its Website is being used to commit unlawful acts, and/or if disclosure of your information is required to comply with applicable laws or regulations, or with a court or administrative order.
                    </Text>
                    
                    <div style={{ height: "48px" }}/>
                  
                    <Text variant={"body1"} regular>
                    Non-personal identifying information ("Usage Information") comprises information that does not identify any specific user. Examples include: information about which of DFS pages are visited on an aggregate level, browser type, operating system type, or IP address. Your Usage Information (not personal) may be disclosed internally within DFS. For example, DFS may disclose Usage Information in order to better understand which parts of the Website users are visiting, to improve the content of its Website, and for marketing, advertising, or research purposes.
                    </Text>
                    <div style={{ height: "48px" }}/>
                  
                  <Text variant={"body1"} regular>
                  Other consulting physicians might be added to your case by your physician if deemed necessary. DFS is not responsible for any voluntary or accidental leak of your personnel information or case details by any of our participating physicians ( all participating physicians are required to sign a privacy policy/non-disclosure upon joining the site )
                  </Text>
                  <div style={{ height: "48px" }}/>
                  
                  <Text variant={"body1"} regular>
                  This Privacy Policy is effective as DFS becomes operational and will remain in effect unless changed. DFS may modify this Privacy Policy at any time at its sole discretion. Such modifications shall be effective one week after posting the modified Privacy Policy on its Website
                  </Text>
                  <div style={{ height: "48px" }}/>
                  
                  <Text variant={"body1"} regular>
                  If you have any questions about this Privacy Policy, the practices of this Website, or your dealings with this Website please contact us.
                  </Text>
                </div>
                
                
            </Container>
            <div style={{ height: "1px", width: "100%", background: "rgb(220,220,220)" }}/>
    </>
)

export default Privacy